<template>
  <div class="time-picker">
    <select class="time-picker__input time-picker__hours" v-model="hours" @change="onHoursChange">
      <option v-for="h in hourOptions" :key="h" :value="pad(h)">
        {{ pad(h) }}
      </option>
    </select>
    <span class="time-picker__separator">:</span>
    <select class="time-picker__input time-picker__minutes" v-model="minutes" @change="emitTime">
      <option v-for="m in minuteOptions" :key="m" :value="pad(m)">
        {{ pad(m) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    /**
     * Шаг в минутах, например 30 → минуты: 00, 30; 15 → 00, 15, 30, 45
     */
    minuteStep: {
      type: Number,
      default: 30,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      hours: '00',
      minutes: '00',
    };
  },
  computed: {
    hourOptions() {
      // 0..24 включительно (24:00 = конец суток)
      const list = [];
      for (let h = 0; h <= 24; h++) list.push(h);
      return list;
    },
    minuteOptions() {
      // если выбрали 24 час — допустима только минута 00
      if (Number(this.hours) === 24) return [0];
      const step = this.minuteStep > 0 ? this.minuteStep : 30;
      const list = [];
      for (let m = 0; m < 60; m += step) list.push(m);
      return list;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(v) {
        if (!v || typeof v !== 'string') {
          this.hours = '00';
          this.minutes = '00';
          return;
        }
        const [h, m] = v.split(':');
        if (h != null && m != null) {
          const hh = Math.max(0, Math.min(24, Number(h)));
          this.hours = this.pad(hh);
          if (hh === 24) {
            this.minutes = '00';
            return;
          }
          const mi = Number(m);
          const step = this.minuteStep > 0 ? this.minuteStep : 30;
          let closest = 0;
          let bestDiff = Infinity;
          for (let mm = 0; mm < 60; mm += step) {
            const diff = Math.abs(mm - mi);
            if (diff < bestDiff) {
              bestDiff = diff;
              closest = mm;
            }
          }
          this.minutes = this.pad(closest);
        }
      },
    },
  },
  methods: {
    pad(v) {
      return String(v).padStart(2, '0');
    },
    onHoursChange() {
      if (Number(this.hours) === 24) this.minutes = '00';
      this.emitTime();
    },
    emitTime() {
      const value = `${this.hours}:${this.minutes}`;
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<style scoped>
.time-picker {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.time-picker__input {
  min-width: 60px;
  height: 32px;
  padding: 0 6px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  font-size: 16px;
}

.time-picker__separator {
  font-size: 16px;
}
</style>
